// import logo from './logo.svg';
import './App.css';
import React from "react";
import * as d3 from "d3";
// import {Grid,Text } from '@geist-ui/core'
import { Grid,Image,Select ,Input ,Divider, Modal,Link, Spacer, useMediaQuery,Text,Tabs } from '@geist-ui/core'
import { Info } from '@geist-ui/icons'
// import { getUser, removeUserSession } from './Utils/Common';
// import MoreVertical from '@geist-ui/icons/moreVertical'
import logo from './img/logo_green.png';
import parnters from './img/partners.png';
import screen1 from './img/screen1.png';
import screen2 from './img/screen2.png';
import screen3 from './img/screen3.png';
import screen4 from './img/screen4.png';


let data = [{"stage":0,"type":"центральні урядові органи","subject":"товари","min":200000,"max":4919745,"loco_yes0":"Якщо ви здійснюєте закупівлю товарів, визначених  підпунктом 2 пункту 6-1 Розділу Х Закону,","loco_yes1":"то ступінь локалізації виробництва таких товарів має дорівнювати або перевищувати розмір, що встановлений в підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":""},
{"stage":1,"type":"центральні урядові органи","subject":"послуги","min":200000,"max":4919745,"loco_yes0":"Якщо ви здійснюєте закупівлю послуг, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону,","loco_yes1":"то ступінь локалізації виробництва таких товарів в складі предмета закупівлі послуги має дорівнювати або перевищувати розмір, що встановлений в підпункті 1 пункту 6-1  Розділу Х Закону","loco_yes2":""},
{"stage":2,"type":"центральні урядові органи","subject":"роботи","min":200000,"max":189220999,"loco_yes0":"Якщо ви здійснюєте закупівлю робіт, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону,","loco_yes1":"то ступінь локалізації виробництва таких товарів в складі предмета закупівлі робіт має дорівнювати або перевищувати розмір, що встановлений в підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":""},
{"stage":3,"type":"інші органи влади","subject":"товари","min":200000,"max":7568839,"loco_yes0":"Якщо ви здійснюєте закупівлю товарів, визначених  підпунктом 2 пункту 6-1 Розділу Х Закону,","loco_yes1":"то ступінь локалізації виробництва таких товарів має дорівнювати або перевищувати розмір, що встановлений в підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":""},
{"stage":4,"type":"інші органи влади","subject":"послуги","min":200000,"max":7568839,"loco_yes0":"Якщо ви здійснюєте закупівлю послуг, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону,","loco_yes1":"то ступінь локалізації виробництва таких товарів в складі предмета закупівлі послуги має дорівнювати або перевищувати розмір, що встановлений в підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":""},
{"stage":5,"type":"інші органи влади","subject":"роботи","min":200000,"max":189220999,"loco_yes0":"Якщо ви здійснюєте закупівлю робіт, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону, ","loco_yes1":"то ступінь локалізації виробництва таких товарів в складі предмета закупівлі робіт має дорівнювати або перевищувати розмір, що встановлений в підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":""},
{"stage":6,"type":"інші установи, підприємства чи організації","subject":"товари","min":200000,"max":15137679,"loco_yes0":"Якщо ви здійснюєте закупівлю товарів, визначених  підпунктом 2 пункту 6-1 Розділу Х Закону, ","loco_yes1":"то ступінь локалізації виробництва таких товарів має дорівнювати або перевищувати розмір, що встановлений в підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":""},
{"stage":7,"type":"інші установи, підприємства чи організації","subject":"послуги","min":200000,"max":15137679,"loco_yes0":"Якщо ви здійснюєте закупівлю послуг, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону,","loco_yes1":"то ступінь локалізації виробництва таких товарів в складі предмета закупівлі послуги має дорівнювати або перевищувати розмір, що встановлений в підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":""},
{"stage":8,"type":"інші установи, підприємства чи організації","subject":"роботи","min":200000,"max":189220999,"loco_yes0":"Якщо ви здійснюєте закупівлю робіт, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону, ","loco_yes1":"то ступінь локалізації виробництва таких товарів в складі предмета закупівлі робіт має дорівнювати або перевищувати розмір, що встановлений в підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":""},
{"stage":9,"type":"центральні урядові органи","subject":"товари","min":4919746,"max":5000000000000,"loco_yes0":"Якщо ви здійснюєте закупівлю товарів, визначених  підпунктом 2 пункту 6-1 Розділу Х Закону,","loco_yes1":"то ви можете здійснити закупівлю таких товарів, якщо їх ступінь локалізації  виробництва дорівнює або перевищує розмір, що  встановлений у підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":"або якщо є сертифікат про походження товару з наступного переліку країн"},
{"stage":10,"type":"центральні урядові органи","subject":"послуги","min":4919746,"max":5000000000000,"loco_yes0":"Якщо ви здійснюєте закупівлю послуг, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону, ","loco_yes1":"то такі товари в складі предмета закупівлі послуги або повинні мати ступінь локалізації виробництва, що дорівнює або перевищує розмір, встановлений в підпункті 1 пункту 6-1 Розділу Х Закону,","loco_yes2":"або мати сертифікат про походження товару з наступного переліку країн"},
{"stage":11,"type":"центральні урядові органи","subject":"роботи","min":189221000,"max":5000000000000,"loco_yes0":"Якщо ви здійснюєте закупівлю робіт, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону,","loco_yes1":"то такі товари в складі предмета закупівлі робіт або повинні мати ступінь локалізації виробництва, що дорівнює або перевищує розмір, встановлений в підпункті 1 пункту 6-1 Розділу Х Закону,","loco_yes2":"або мати сертифікат про походження товару з наступного переліку країн"},
{"stage":12,"type":"інші органи влади","subject":"товари","min":7568840,"max":5000000000000,"loco_yes0":"Якщо ви здійснюєте закупівлю товарів, визначених  підпунктом 2 пункту 6-1 Розділу Х Закону,","loco_yes1":"то ви можете здійснити закупівлю таких товарів, якщо їх ступінь локалізації виробництва дорівнює або перевищує розмір, що встановлений у підпункті 1 пункту 6-1 Розділу Х Закону,","loco_yes2":"або якщо є сертифікат про походження товару з наступного переліку країн"},
{"stage":13,"type":"інші органи влади","subject":"послуги","min":7568840,"max":5000000000000,"loco_yes0":"Якщо ви здійснюєте закупівлю послуг, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону,","loco_yes1":"то такі товари в складі предмета закупівлі послуги або повинні мати ступінь локалізації виробництва, що дорівнює або перевищує розмір, встановлений в підпункті 1 пункту 6-1 Розділу Х Закону,","loco_yes2":"або мати сертифікат про походження товару з наступного переліку країн"},
{"stage":14,"type":"інші органи влади","subject":"роботи","min":189221000,"max":5000000000000,"loco_yes0":"Якщо ви здійснюєте закупівлю робіт, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону,","loco_yes1":"то такі товари в складі предмета закупівлі робіт або повинні мати ступінь локалізації виробництва, що дорівнює або перевищує розмір, встановлений в підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":"або мати сертифікат про походження товару з наступного переліку країн"},
{"stage":15,"type":"інші установи, підприємства чи організації","subject":"товари","min":15137680,"max":5000000000000,"loco_yes0":"Якщо ви здійснюєте закупівлю товарів, визначених  підпунктом 2 пункту 6-1 Розділу Х Закону, ","loco_yes1":"то ви можете здійснити закупівлю таких товарів, якщо їх ступінь локалізації  виробництва дорівнює або перевищує розмір, що  встановлений у підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":"або якщо є сертифікат про походження товару з наступного переліку країн"},
{"stage":16,"type":"інші установи, підприємства чи організації","subject":"послуги","min":15137680,"max":5000000000000,"loco_yes0":"Якщо ви здійснюєте закупівлю послуг, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону, ","loco_yes1":"то такі товари в складі предмета закупівлі послуги або повинні мати ступінь локалізації виробництва, що дорівнює або перевищує розмір, встановлений в підпункті 1 пункту 6-1 Розділу Х Закону,","loco_yes2":"або мати сертифікат про походження товару з наступного переліку країн"},
{"stage":17,"type":"інші установи, підприємства чи організації","subject":"роботи","min":189221000,"max":5000000000000,"loco_yes0":"Якщо ви здійснюєте закупівлю робіт, надання яких передбачає набуття замовником у власність товарів, визначених підпунктом 2 пункту 6-1 Розділу Х Закону, ","loco_yes1":"то такі товари в складі предмета закупівлі робіт або повинні мати ступінь локалізації виробництва, що дорівнює або перевищує розмір, встановлений в підпункті 1 пункту 6-1 Розділу Х Закону","loco_yes2":"або мати сертифікат про походження товару з наступного переліку країн"}]




const testStyle = {
  border: "2px solid #fff",
  background:"#f0f0f0",
  padding:"10px"
};



function App() {
  const isXS = useMediaQuery('xs')

  const [type, setType] = React.useState('центральні урядові органи');
  const [subject, setSubject] = React.useState('товари');
  const [expv, setExpv] = React.useState(0) 
  const [result, setResults] = React.useState([]) 

  const [mod0, setMod0] = React.useState(false);
  const [mod1, setMod1] = React.useState(false);
  const [mod2, setMod2] = React.useState(false);
  const [mod3, setMod3] = React.useState(false);


  const [tab, setTab] = React.useState('1')
  const changeHandler = val => setTab(val)

  
  React.useEffect(() => {

    setResults(data.filter( d => d.type==type && d.subject==subject && (expv>=d.min && expv<d.max)))
    
  }, [type,subject,expv]);



  console.log('STEP loko: ',type,subject,expv,'-->',result)


  return (
    <>

<Grid.Container justify="center" direction="row" alignItems="center"
      style={{'background':'#333'}}
      >
         <Grid xs={8} sm={8} md={4} direction="row">
         <Link href="https://cep.kse.ua/">         
          <Image width={10} src={logo} />
         </Link>

            </Grid>
            <Grid xs={16} sm={16} md={20} direction="row">
            <Text h4 style={{lineHeight:1.1, color:'#fff'}}>
            Локалізація-tool: помічник закупівельника
        </Text >
        </Grid>
        
</Grid.Container>






<Tabs initialValue="1" onChange={changeHandler}>
<Tabs.Item label="Головна" value="1">
<Spacer h={2}/>
<Grid.Container justify="center">
      <Grid direction="row" style={testStyle} xs={22} sm={22} md={8}>
      <span style={{paddingTop:'10px',fontSize:'16px',lineHeight:1}}>Замовник:</span>
            <Select placeholder="центральні урядові органи" 
              onChange={val => setType(val)}
              // style={{width:'70%'}}
              >
                <Select.Option value="центральні урядові органи">центральні урядові органи</Select.Option>
                <Select.Option value="інші органи влади">інші органи влади</Select.Option>
                <Select.Option value="інші установи, підприємства чи організації">інші установи, підприємства чи організації</Select.Option>
            </Select>
            <Info size={18} color="#333" onClick={() => setMod0(true)}/> 
      </Grid>    
        
      <Grid direction="row" style={testStyle} xs={22} sm={22} md={7}>
      <span style={{paddingTop:'10px',fontSize:'16px',lineHeight:1}}>планує закуповувати:</span>
            <Select placeholder="товари"  
            // style={{width:'70%'}}
                onChange={val => setSubject(val)}
                >
                  <Select.Option value="товари">товари</Select.Option>
                  <Select.Option value="послуги">послуги</Select.Option>
                  {/* <Select.Option value="будівельні послуги">будівельні послуги</Select.Option> */}
                  <Select.Option value="роботи">роботи</Select.Option>
            </Select>
            {/* <Info size={18} color="#aaa" onClick={()=>{setOpen2(true)}}/> */}
           
            </Grid>    

            <Grid direction="row" style={testStyle} xs={22} sm={22} md={7}>
            <span style={{paddingTop:'10px',fontSize:'16px',lineHeight:1}}>очікуваною вартістю: </span>
            <Input type="secondary" value={expv} onChange={(e)=>setExpv(+e.target.value)} placeholder="очікувана вартість, грн" />
            <span style={{paddingTop:'10px',fontSize:'16px',lineHeight:1}}>грн</span>
            </Grid>    
</Grid.Container>




<Grid.Container justify="center" style={{paddingTop:"50px"}}>
          <Grid item xs={22} sm={22} md={22}>
          
          {result.length==0&&"Не підпадає під дію Закону"}

          {result.length>0&&
         <Text> 
          {result[0].loco_yes0}<Info size={18} color="#333" onClick={() => setMod1(true)}/>
          {result[0].loco_yes1}<Info size={18} color="#333" onClick={() => setMod2(true)}/> 
          {result[0].stage>=9&&<>{result[0].loco_yes2}<Info size={18} color="#333" onClick={() => setMod3(true)}/></>}
         </Text>
          }
            
          </Grid>
        
      </Grid.Container>
</Tabs.Item>




<Tabs.Item label="Про локалізацію" value="2">
<Text blockquote my={1}>
{/* <Text h4>Передумови для створення Локалізація-tool:помічник закупівельника
</Text> */}
<Text>Законом України від 16 грудня 2021 року № 1977- ІХ “Про внесення змін до Закону України “Про публічні закупівлі” щодо створення передумов для сталого розвитку та модернізації вітчизняної промисловості” було внесено зміни, зокрема до Розділу Х “Прикінцеві та перехідні положення” (далі - Розділ Х Закону).
</Text>
<Text>Так, пунктом 6-1 Розділу Х Закону встановлено особливості здійснення закупівель, якщо вартість предмету закупівель дорівнює або перевищує 200 000 грн.</Text>
<Text>Передбачається, що протягом 10 років, починаючи з 2022 року, замовник здійснює закупівлі товарів, виключно якщо їх ступінь локалізації виробництва дорівнює чи перевищує:</Text>
<ul>
<li><Text>у 2022 році - 10 відсотків;</Text></li>
<li><Text>у 2023 році - 15 відсотків;</Text></li>
<li><Text>у 2024 році - 20 відсотків;</Text></li>
<li><Text>у 2025 році - 25 відсотків;</Text></li>
<li><Text>у 2026 році - 30 відсотків;</Text></li>
<li><Text>у 2027 році - 35 відсотків;</Text></li>
<li><Text>з 2028 року до дня завершення 10-річного строку дії цього пункту - 40 відсотків.</Text></li>
</ul>
<Text>Варто зазначити, що Кабінет Міністрів України за погодженням із комітетом Верховної Ради України, до предмета відання якого належать питання промислової політики та розвитку окремих галузей виробництва, може:</Text>
<Text>- щороку, не пізніше 31 жовтня, змінювати ступінь локалізації виробництва на наступний календарний рік до 5 відсотків у бік зменшення або до 10 відсотків у бік збільшення щодо кожного окремого товару, визначеного підпунктом 2 пункту 6-1;</Text>
<Text>- зменшити ступінь локалізації виробництва для проведення окремої закупівлі товару, визначеного підпунктом 2 пункту 6-1;</Text>
<Text>- затверджувати додатковий перелік товарів, що належать виключно до продукції переробної промисловості, в якому встановлює вимоги щодо їх ступеня локалізації виробництва в розмірі, що не перевищує ступінь локалізації виробництва, на відповідний рік.</Text>
 
<Text>Разом з тим,  особливості, визначені пунктом 6-1 Розділу Х Закону, не застосовується до закупівель, які підпадають під дію положень Закону України "Про приєднання України до Угоди про державні закупівлі", а також положень про державні закупівлі інших міжнародних договорів України, згода на обов’язковість яких надана Верховною Радою України.</Text>


</Text>
</Tabs.Item>


  <Tabs.Item label="Опис інструменту" value="3">
  <Text blockquote my={1}>
  {/* <Text h4>Опис Локалізація-tool:помічник закупівельника</Text> */}
  <Text>
  З метою забезпечення коректної роботи Локалізація-tool ми проаналізували наявні міжнародні договори, згода на обов'язковість яких надана Верховною Радою України. 
  </Text>  <Text>
На сьогодні таких угод, в яких містяться положення щодо закупівель, п’ять. Серед них Угода про державні закупівлі Світової організації торгівлі (далі-УДЗ), яка налічує 47 країн, в тому числі Європейський союз та 27 його держав-членів та Угода про асоціацію між Україною, з одного боку, та Європейським Союзом, Європейським співтовариством з атомної енергії та їх державами-членами (далі-Угода про асоціацію).
Україна приєдналася до УДЗ в 2016 році та, з цього моменту, зобов'язана неухильно виконувати правила, які визначені в УДЗ для всіх країн учасниць угоди. Оскільки положеннями УДЗ передбачено, що вона застосовується до будь-якого закону, нормативного акту,  процедури чи практики,  які стосуються будь-якої  закупівлі організаціями, що  охоплюються  цією Угодою.
</Text>  <Text>
Разом з тим Угода про асоціацію була ратифікована Україною у 2014 році, а стороною ЄС у 2016 році, саме тоді коли Україна стала країною - учасницею УДЗ. При цьому, до загальних цілей створення асоціації між Україною та Союзом і його державами - членами, зокрема, відноситься сприяння <b>поступовому</b> зближенню Сторін, ґрунтуючись на спільних цінностях і тісних привілейованих зв’язках. А конкретно для державних закупівель - впровадження ефективного, взаємного і <b>поступового відкриття відповідних ринків закупівель.</b>
</Text>  <Text>
Отже, при розробці Локалізація-tool, ми спиралися на обов'язкові положення, закріплені в  УДЗ (зокрема, щодо видів замовників та вартісних меж, визначених в УДЗ) та які набули чинності відразу у 2016 році після ратифікації Верховною Радою України. У свою чергу, УДЗ оперує такою спеціальною грошовою одиницею як СПЗ.
</Text>  <Text>
Нагадуємо, що спеціальні права запозичення (СПЗ) (англ. special drawing rights, SDR, SDRs) — резервний та платіжний засіб, що емітується Міжнародним Валютним Фондом (МВФ). Існує лише в безготівковій формі у вигляді записів на банківських рахунках. 
</Text>  <Text>
Розрахунок порогових значень базується на середньому денному курсі національної валюти в СПЗ за попередній дворічний період (наприклад, на 2022–2023 рр. розрахунок проводиться з урахуванням курсу з листопада 2019 року по жовтень 2021 року). На 2022–2023 рр. для України цей курс складає 1 СПЗ = 37,8442 грн. Наступне коригування порогових значень буде здійснено через два роки і набуде чинності з 01.01.2024.
Тож Локалізація-tool, як допоміжний  інструмент для застосування вимоги щодо локалізації базується на зобов'язальних положеннях УДЗ та відповідно на підставі розрахунку шляхом множення вартісних меж в СПЗ на діючий обмінний курс в 2022-2023 році. 
</Text>
</Text>
  </Tabs.Item>

  <Tabs.Item label="Дії замовника" value="4">
  <Text blockquote my={1}>
  {/* <Text h4>Рекомендований алгоритм дій замовника</Text> */}
  <Text>
  Якщо ви плануєте закуповувати товари, які входить до переліку, що наведений у додатку, або роботи чи послуги, надання яких передбачає набуття замовником у власність товарів, які входять до вищезазначеного переліку, то  Локалізація-tool допоможе вам визначитися, як це зробити з огляду на вимоги, визначені у пункті 6-1 Розділу Х Закону.
</Text>
<Text>Важливо! Крім переліку, що наданий у додатку,  варто перевірити чи не приймалися КМУ рішення, якими затверджені додаткові переліки товарів з визначеним ступенем локалізації.
</Text>
<Text className='dicsl'>
<Text h3>Крок 1.</Text> Оберіть до якого виду замовника ви належите, скориставшись  випадаючим списком
</Text>
<Image width="50rem" src={screen1} />
<Text className='dicsl'>
<Text h3>Крок 2.</Text> Оберіть предмет закупівлі з випадаючого списку:
</Text>
<Image width="50rem" src={screen2} />
<Text className='dicsl'>
<Text h3>Крок 3.</Text> Вкажіть очікувану вартість предмета закупівлі 
</Text>
<Image width="50rem" src={screen3} />
<Text className='dicsl'>
  і ви отримаєте рекомендацію 
</Text>
<Image width="50rem" src={screen4} />

</Text>
  </Tabs.Item>
</Tabs>









<Spacer h={11}/>

<Divider />

<Grid.Container justify="center">

  <Grid item xs={22} sm={8} md={7}>
    <img id='partners' src={parnters} style={{width: "300px",height:'60px',paddingTop:"0px"}}></img>
  </Grid>
  <Grid item xs={22} sm={9} md={9}>
    <Text font={"12px"} style={{ color: '#ccc',paddingRight:'30px' }}>
  Цей сервіс створено Центром вдосконалення закупівель Київської школи економіки за підтримки USAID/UK aid проєкту ”Прозорість та підзвітність у державному управлінні та послугах/TAPAS” Дозволяє швидко визначати необхідність застосування передбаченого ступеня локалізації виробництва під час закупівель товарів, а також робіт і послуг, надання яких передбачає набуття замовником у власність товарів. 
    </Text>
  </Grid>

  <Grid item xs={22} sm={5} md={5}>
    <Text font={"12px"} style={{ color: '#ccc' }}>Центр вдосконалення закупівель Kyiv School of Economics.  
                Київ, вул. Шпака, 3, Email: ksetools@kse.org.ua
    </Text>
  </Grid>

</Grid.Container>





<Modal visible={mod0} width="60rem">
        <Modal.Subtitle>Як визначити тип замовника</Modal.Subtitle>
        <Modal.Content>
       
        <>
            До центральних урядових органів відносяться: 
            <ul>
            <li>1.Органи управління діяльністю Верховної Ради України, Президента України та Кабінету Міністрів України. Міністерства, інші центральні органи виконавчої влади, урядові органи, створені у системі центральних органів виконавчої влади. </li>
            <li>2.Конституційний Cуд України, Верховний Cуд України та вищі спеціалізовані суди.</li>
            <li>3.Установи та організації, визначені Конституцією України, або які є частиною Кабінету Міністрів України, а також, спеціально уповноважені розвідувальні органи, а також органи, установи і організації, які є головними розпорядниками коштів державного бюджету відповідно до українського законодавства (наприклад, Національний банк, Антимонопольний комітет, Генеральна прокуратура, Рахункова палата тощо). </li>
            <li>4.Національна академія наук України та галузеві академії наук.</li>
            <li>5.Інші установи та організації, які підпорядковані зазначеним вище органам, і які фінансуються з державного бюджету </li>
</ul>

До інших органів влади відносяться:
<ul>
<li> 1.Органи виконавчої влади (у районах, районах Автономної Республіки Крим, містах Києві та Севастополі): a. місцеві державні адміністрації; b. місцеві управління (обласні або регіональні управління) міністерств та інших центральних органів виконавчої влади. </li>
<li>2.Обласні та місцеві органи влади (наприклад область, район, місто, район у місті, селище, село): а. виконавчі органи та секретаріати місцевих рад. </li>
<li>3. Органи, які забезпечують функціонування Автономної Республіки Крим: a. Парламент Автономної Республіки Крим; b. Рада міністрів Автономної Республіки Крим; c. міністерства та інші органи державної влади Автономної Республіки Крим.</li>
<li>4. Інші установи та організації, які фінансуються з державного або місцевих бюджетів.</li>
</ul>

До інших установ, підприємств чи організації відносяться установи, підприємства чи організації, які здійснюють діяльність у таких сферах: 
 <ul>
<li>1. забезпечення виробництва, транспортування, постачання, зберігання газу;</li>
<li>2. забезпечення виробництва, транспортування та постачання теплової енергії; </li>
<li>3. забезпечення виробництва, транспортування та постачання електричної енергії; </li>
<li>4. забезпечення виробництва, транспортування та постачання питної води; </li>
<li>5. забезпечення функціонування об’єктів централізованого водовідведення та каналізації; </li>
<li>6. надання послуг з використання інфраструктури залізничного транспорту загального користування;</li>
<li>7. забезпечення функціонування міського електричного транспорту та експлуатація його об’єктів для надання послуг з перевезення; </li>
<li>8. надання послуг автобусних станцій, портів, аеропортів; </li>
<li>9. надання послуг з аеронавігаційного обслуговування польотів повітряних суден; </li>
<li>10. надання послуг поштового зв’язку;</li>
<li>11. геологічне дослідження (у тому числі дослідно-промислова розробка) нафтогазоносних надр, родовищ вугілля та інших видів твердого палива; </li>
<li>12. забезпечення експлуатації та управління фіксованими телекомунікаційними мережами загального користування або надання телекомунікаційних послуг загального користування; </li>
<li>13. забезпечення транспортування, зберігання та переробки сирої нафти і нафтопродуктів. </li>
</ul>
            </>

        </Modal.Content>
        <Modal.Action passive onClick={() => setMod0(false)}>Закрити</Modal.Action>
      </Modal>





      <Modal visible={mod1} width="40rem">
        <Modal.Subtitle> ПЕРЕЛІК ТОВАРІВ</Modal.Subtitle>
        <Modal.Content>
       
(до яких застосовуються особливості, визначені пунктом 6-1 Розділу Х)
<ul> 
<li>дизель-генераторні установки;</li>
<li>генераторні установки з двигуном із іскровим запалюванням;</li>
<li>турбогенераторні установки;</li>
<li>трансформатори;</li>
<li>трансформатори з рідинним діелектриком;</li>
<li>трансформатори напруги;</li>
<li>вимірювальні трансформатори;</li>
<li>трансформатори живлення;</li>
<li>електричні конденсатори;</li>
<li>конденсатори постійної ємності;</li>
<li>конденсатори змінної та регульованої ємності;</li>
<li>автомобілі швидкої допомоги;</li>
<li>транспортні засоби для перевезення пацієнтів;</li>
<li>мототранспортні засоби для перевезення 10 і більше осіб;</li>
<li>міські та туристичні автобуси;</li>
<li>громадські автобуси;</li>
<li>двосекційні автобуси;</li>
<li>низькопідлогові автобуси;</li>
<li>туристичні автобуси;</li>
<li>мототранспортні вантажні засоби;</li>
<li>автоцистерни;</li>
<li>автоцистерни для перевезення паливно-мастильних матеріалів;</li>
<li>самоскиди;</li>
<li>фургони;</li>
<li>великовантажні мототранспортні засоби;</li>
<li>автокрани та вантажні автомобілі-самоскиди;</li>
<li>вантажні автомобілі з підіймальними платформами;</li>
<li>вантажні автомобілі-самоскиди;</li>
<li>мототранспортні засоби спеціального призначення;</li>
<li>пересувні бурові вежі;</li>
<li>пожежні транспортні засоби;</li>
<li>пожежні автомобілі з поворотною драбиною;</li>
<li>пожежні автоцистерни;</li>
<li>пожежні автомобілі;</li>
<li>транспортні засоби аварійно-ремонтного призначення;</li>
<li>підмітально-прибиральні машини;</li>
<li>підмітально-збиральні машини з вакуумно-пневматичною системою;</li>
<li>поливальні машини;</li>
<li>сміттєвози та асенізаційні машини;</li>
<li>сміттєвози;</li>
<li>сміттєзбиральні машини;</li>
<li>вантажоперевізні транспортні засоби;</li>
<li>електробуси;</li>
<li>кузови, причепи та напівпричепи;</li>
<li>кузови транспортних засобів;</li>
<li>причепи, напівпричепи та пересувні контейнери;</li>
<li>причепи та напівпричепи;</li>
<li>напівпричепи;</li>
<li>причепи;</li>
<li>причепи загального призначення;</li>
<li>залізничні та трамвайні локомотиви і рейковий рухомий склад та супутні деталі;</li>
<li>залізничні локомотиви та тендери;</li>
<li>локомотиви;</li>
<li>локомотивні тендери;</li>
<li>рейковий рухомий склад;</li>
<li>вантажні залізничні вагони;</li>
<li>транспортні засоби для ремонту та обслуговування залізничних доріг;</li>
<li>залізничні та трамвайні пасажирські вагони і тролейбуси;</li>
<li>трамвайні пасажирські вагони;</li>
<li>залізничні пасажирські вагони;</li>
<li>тролейбуси;</li>
<li>залізничні вагони;</li>
<li>багажні вагони та вагони спеціального призначення;</li>
<li>самохідні частини;</li>
<li>вертольоти, літаки, космічні та інші літальні апарати з двигуном;</li>
<li>вертольоти та літаки;</li>
<li>вертольоти;</li>
<li>двигуни для повітряних літальних апаратів;</li>
<li>турбореактивні двигуни;</li>
<li>турбогвинтові двигуни;</li>
<li>реактивні двигуни;</li>
<li>навчально-тренувальні літаки;</li>
<li>пошуково-рятувальні вертольоти;</li>
<li>турбіни та мотори;</li>
<li>парові турбіни;</li>
<li>гідравлічні турбіни;</li>
<li>водяні колеса;</li>
<li>насоси та компресори;</li>
<li>насоси;</li>
<li>насоси для рідин;</li>
<li>відцентрові насоси та підіймачі рідин;</li>
<li>підіймачі рідин;</li>
<li>відцентрові насоси;</li>
<li>компресори;</li>
<li>газові компресори;</li>
<li>роторні компресори;</li>
<li>повітряні компресори;</li>
<li>турбокомпресори;</li>
<li>поршневі об’ємні компресори;</li>
<li>машини спеціального призначення різні;</li>
<li>гірничодобувне та будівельне обладнання;</li>
<li>врубові та тунелепрохідні, бурильні чи прохідницькі машини для добування вугілля чи гірських порід;</li>
<li>прохідні комбайни;</li>
<li>прохідні машини;</li>
<li>машини для земляних і землерийних робіт та їх частини;</li>
<li>машини для земляних робіт;</li>
<li>фронтальні ковшові навантажувачі зі зворотною лопатою;</li>
<li>механічні лопати, екскаватори та ковшові навантажувачі, гірнича техніка;</li>
<li>механічні лопати;</li>
<li>механічні ковшові навантажувачі;</li>
<li>землерийні машини;</li>
<li>механічні екскаватори;</li>
<li>машини для змішування гравію з бітумом</li>

</ul>

        </Modal.Content>
        <Modal.Action passive onClick={() => setMod1(false)}>Закрити</Modal.Action>
      </Modal>





      <Modal visible={mod2} >
        <Modal.Subtitle>Відсотки в розрізі років</Modal.Subtitle>
        <Modal.Content>
        <ul>
<li><Text>у 2022 році - 10 відсотків;</Text></li>
<li><Text>у 2023 році - 15 відсотків;</Text></li>
<li><Text>у 2024 році - 20 відсотків;</Text></li>
<li><Text>у 2025 році - 25 відсотків;</Text></li>
<li><Text>у 2026 році - 30 відсотків;</Text></li>
<li><Text>у 2027 році - 35 відсотків;</Text></li>
<li><Text>з 2028 року до дня завершення 10-річного строку дії цього пункту - 40 відсотків.</Text></li>
</ul>
        </Modal.Content>
        <Modal.Action passive onClick={() => setMod2(false)}>Закрити</Modal.Action>
      </Modal>




      <Modal visible={mod3} >
        <Modal.Subtitle>Відсотки в розрізі років</Modal.Subtitle>
        <Modal.Content>
        <ul>
        
        <li>Швейцарська Конфедерація</li>
        <li>Князівство Ліхтенштейн</li>
        <li>Королівство Норвегія</li>
        <li>Республіка Ісландія</li>
        <li>Республіка Австрія</li>
        <li>Королівство Бельгія</li>
        <li>Республіка Болгарія</li>
        <li>Грецька республіка</li>
        <li>Королівство Данія </li>
        <li>Естонська республіка</li>
        <li>Ірландія</li>
        <li>Королівство Іспанія</li>
        <li>Італійська республіка</li>
        <li>Республіка Кіпр</li>
        <li>Латвійська Республіка</li>
        <li>Литовська Республіка</li>
        <li>Велике Герцогство Люксембург</li>
        <li>Республіка Мальта</li>
        <li>Королівство Нідерланди</li>
        <li>Федеративна Республіка Німеччина</li>
        <li>Республіка Польща</li>
        <li>Португальська Республіка</li>
        <li>Румунія</li>
        <li>Словацька Республіка</li>
        <li>Республіка Словенія</li>
        <li>Угорщина</li>
        <li>Фінляндська Республіка</li>
        <li>Французька Республіка</li>
        <li>Республіка Хорватія</li>
        <li>Чеська Республіка</li>
        <li>Королівство Швеція</li>
        <li>Австралія</li>
        <li>Сполучене Королівство Великої Британії та Північної Ірландії</li>
        <li>Республіка Вірменія</li>
        <li>Спеціальний адміністративний район Гонконг (Китайська Народна Республіка)</li>
        <li>Держава Ізраїль</li>
        <li>Королівство Нідерланди стосовно Аруби</li>
        <li>Канада</li>
        <li>Республіка Корея</li>
        <li>Республіка Молдова</li>
        <li>Нова Зеландія</li>
        <li>Республіка Сінгапур</li>
        <li>Сполучені Штати Америки</li>
        <li>Окрема митна територія Тайваню, Пенху, Кінмен і Матсу</li>
        <li>Чорногорія</li>
        <li>Японія</li>
        </ul>
        </Modal.Content>
        <Modal.Action passive onClick={() => setMod3(false)}>Закрити</Modal.Action>
      </Modal>


    </>
  );
}



export default App;
